import $ from "jquery";
//import { checkNested, getConfig, updateQueryStringParameter } from '../../scripts/general_functions.js';
import { getApiWarnings } from "../../scripts/warnings";
import language from "../../scripts/translation";

export default function(client) {

    $("body").on("click", ".fullnav__breadcrumb__link", function() {

        let links = decodeURIComponent($(this).attr("data-children"));
        links = JSON.parse(links);

        $(this).parent().nextAll().remove();
        insertMenu(links);
    });
 
    const res = client,
        logo = res.logo[0],
        style = (logo.inlineStyles && logo.inlineStyles.length > 0 ? "style='" + logo.inlineStyles + "'" : ""),
        cssclass = (logo.cssclass && logo.cssclass.length > 0 ? logo.cssclass : "");

    document.title = res.name;
    getApiWarnings();

    let searchButton = "";
    if(res.searchEnabled)
        searchButton = `<button class="header__button__search" type="button" role="search">
                            <span class="material-icons-outlined header__icon"></span>
                            <span class="header__button__text">Søk</span>
                        </button>`;
    let groupHeader = "";
    if(res.groupHeader)
        groupHeader = `<div class="header__group-container ${res.groupHeader.cssclass}"><a href="${res.groupHeader.link}" target="${res.groupHeader.target == undefined ? "_blank" : res.groupHeader.target}"><img src="${res.groupHeader.filepath}" alt="${res.groupHeader.alttext}" /></a></div>`;

    const headerHtml = `
        ${groupHeader}
        <nav class="navbar navbar-default navbar-fixed-top header__nav header header__shadow">
          <div class="container p-md-0">
             <div class="row">
                <div class="col-md-12">
                    <div class="header--container">
                        <a href="/" @click="reload">
                            <div class="header__shield-container align-middle">
            			        <img class="header__shield align-middle ${cssclass}" alt="${logo.alttext}" src="${logo.filepath}"  ${style} /> 
            			    </div>
        			    </a>
			            <div class="skip-link">
                            <ul>
                                <li>
                                    <a class="skip" href="#maincontent">${language("HEADER_JUMPMAIN")}</a>
                                </li>
                                <!--li>
                                    <a class="skip" href="#menu_container">${language("HEADER_JUMPNAV")}</a>
                                </li-->
                                <li>
                                    <a class="skip" href="/">${language("HEADER_JUMPSTART")}</a>
                                </li>
                            </ul>
                        </div>
                        
                        <div class="header__icon-container">
                            ${customLinks(res.headerLinks)}
                            ${searchButton}
                            <button class="header__button__navigation hamburger hamburger--spin" aria-label="Meny" aria-controls="menu_container" type="button">
                                <span class="hamburger-box">
                                    <span class="hamburger-inner">&nbsp;</span>
                                </span>
                                <span class="header__button__text">Meny</span>
                            </button>
                        </div> 
                    </div>
                </div>
             </div>
             <div class="row">
                <div class="col p-0">
                    <div class="header--searchcontainer">
                        <div class="header__search">
                            <div class="header__search__container">
                                <input type="text" name="searchsite" value="" class="input-control header__search__input" >
                                <button class="header__button__dosearch">
                                    <span class="material-icons-outlined header__icon">&#xE8B6;</span>
                                </button>
                            </div>
                        </div>
                        <div class="header__search__closebutton"><span class="material-icons-outlined header__search__closebutton__icon">close</span></div>
                    </div>
                </div>
             </div>
          </div>
        </nav>
        
        <div class="fullnav" id="menu_container">
            <div class="container p-md-0">
                <div class="row">
                    <div class="col-12">
                        <div class="fullnav__breadcrumb__container">
                            <div class="row fullnav__main">&nbsp;</div>
                        </div>
                        <div class="fullnav__extra"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="chatbot__container " id="chatbot__container"></div>
        <div class="warnings" id="warnings_container">&nbsp;</div>
        `;

    document.getElementById("header").innerHTML = headerHtml;

    $("html").on("click", ".header__button__navigation", function(e) {
        $("body,html").scrollTop(0);
        $(this).toggleClass("is-active");
        $(".header").toggleClass("is-active");
        $(".fullnav").toggle();
        let txt = "Meny";
        if ($(this).hasClass("is-active")) {
            txt = "Lukk"
        }
        $(this).find(".header__button__text").text(txt);
    });

    $("html").on("click", ".header__button__search", function(e) {
        $(".header--searchcontainer").css('display', 'flex');
        $(".header--searchcontainer").css('position', 'absolute');
        $(".frontpage_template .header--searchcontainer").css('position', 'relative');
        //$(".header").toggleClass("is-active");
        $(this).toggleClass("is-active");

        $(".header__search__input").focus().keyup(function(e) {
            let key = e.keyCode || e.which;
            let searchstring = $(this).val();
            if (key === 13 && searchstring.length > 0) {
                parent.location = "/search/" + searchstring;
            }
        });
        let txt = "Søk";
        if ($(this).hasClass("is-active")) {
            txt = "Lukk"
        }
        $(this).find(".header__button__text").text(txt);
        if (!$(this).hasClass("is-active")) {
            $(".header--searchcontainer").hide();
        }
    });

    $("html").on("click", ".header__button__dosearch", function(e) {
        let searchstring = $(".header__search__input").val();
        if (searchstring.length > 0) {
            parent.location = "/search/" + searchstring;
        }
    });

    $("body").on("click", ".header__search__input", function(e) {
        e.stopPropagation();
    });

    $("html").on("click", ".header__button__link", function(e) {
        $("body,html").scrollTop(0);
        $(this).toggleClass("is-active");
        $(".header").toggleClass("is-active");
        parent.location = $(this).attr("data-link");
    });

    let langSelector = document.querySelector(".header__button__translate");
    if(langSelector!=undefined) {
        document.querySelector(".header__button__translate").addEventListener("click", function(e) {
            document.querySelector(".google-translate-panel").classList.toggle("d-none");
        });
    }

    $(".header__search__closebutton").on("click", function() {
        if (!$("this").hasClass("header__button__dosearch")) {
            $(".header__button__text.is-active").removeClass("is-active");
            $(".header--searchcontainer").hide();
        }
        $(".header__button__search").toggleClass("is-active");
        let txt = "Søk";
        if ($(".header__button__search").hasClass("is-active")) {
            txt = "Lukk"
        }
        $(".header__button__search").find(".header__button__text").text(txt);
    });

    if ($(document).width() < 768) {
        var destination = $(".fullnav__main");
        $(".header__custom-container").insertBefore(destination);
    }
}
export const customLinks = (customLinks) => {
    let result = ``;
    let itemList = ``;

    let langSelector = client.showLanguages == true ? `
        <span class="row header__translate__container justify-content-sm-center">
            <button class="header__button__translate" data-js="gTranslate">
                <span class="header__button__text">Language</span>
                <span class="material-icons-outlined header__icon" aria-hidden="true">
                    expand_more
                </span>
            </button>
            <div class="google-translate-panel d-none" role="application" aria-label="google translate">
                <div id="google_translate_element"></div>
            </div>
        </span>
        ` : ``;

    if (customLinks != undefined && customLinks.length > 0) {
        customLinks.forEach(function(item) {
            itemList += `
                <button class="header__button__link ${item.cssClass}" data-link="${item.link}" type="button">
                    <span class="material-icons-outlined header__icon" aria-hidden="true">${item.icon}</span>
                    <span class="header__button__text">${item.title}</span>
                </button>`;
        });
        result = `
            <div class="header__custom-container">
                ${langSelector}
                ${itemList}
            </div>`;
    }
    else if (langSelector != "") {
        result = `
            <div class="header__custom-container">
                ${langSelector}
                ${itemList}
            </div>`;
    }
    return result;
}
